exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-wrapper[data-v-565b7466]{position:relative;height:100%;width:100%}.app-wrapper[data-v-565b7466]:after{content:'';display:table;clear:both}.drawer-bg[data-v-565b7466]{background:#000;opacity:0.3;width:100%;top:0;height:100%;position:absolute;z-index:999}\n", ""]);

